import { useOrderFlowContext } from '@euler/app/flows/order/OrderFlowContext';
import { WiredFacadeMediaListView } from '@euler/app/flows/order/pages/FacadeInspectionScreen/components/FacadeMediaListView';
import { FacadeScreenEvent } from '@euler/app/flows/order/types';
import { FacadeMediaInfo } from '@euler/app/flows/task/pages/pre-inspection/functions/types';
import { SiteInspectionType } from '@euler/model/enum';
import { useBehaviorSubject } from '@euler/utils/hooks';
import { memo, useCallback } from 'react';
import { Subject } from 'rxjs';

export const WiredSiteInspectionResults = memo(
  ({ event$ }: { event$: Subject<FacadeScreenEvent> }) => {
    const { orderDetail$ } = useOrderFlowContext();

    const [orderDetail] = useBehaviorSubject(orderDetail$);
    const siteInspections = orderDetail.preInspection?.filter(
      x => x.inspectionType === SiteInspectionType.Facade,
    );

    const onRetryUpload = useCallback(
      (media: FacadeMediaInfo) => {
        event$.next({ type: 'retryUpload', media });
      },
      [event$],
    );

    const onAdd = useCallback(
      (code: string) => {
        event$.next({ type: 'add', code });
      },
      [event$],
    );

    if (!siteInspections?.length) {
      return null;
    }

    return (
      <>
        {siteInspections.map(siteInspection => (
          <WiredFacadeMediaListView
            siteInspection={siteInspection}
            key={siteInspection.siteCode}
            onRetryUpload={onRetryUpload}
            onAdd={onAdd}
          />
        ))}
      </>
    );
  },
);
